module.exports = __webpack_public_path__ + "static/media/farm.1d2ef6c5.jpg";